'use client';

import React, { createContext, useState, useContext, ReactNode } from 'react';

interface EditorContextType {
  isAgentMode: boolean;
  setIsAgentMode: (isAgentMode: boolean) => void;
}

const EditorContext = createContext<EditorContextType | undefined>(undefined);

export const EditorProvider = ({ children }: { children: ReactNode }) => {
  const [isAgentMode, setIsAgentMode] = useState(false);

  return (
    <EditorContext.Provider value={{ isAgentMode, setIsAgentMode }}>
      {children}
    </EditorContext.Provider>
  );
};

export const useEditor = () => {
  const context = useContext(EditorContext);
  if (context === undefined) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
};
